<div class="d-flex w-100 flex-wrap">
    <div class="file-explorer-breadcrumb py-2 d-flex flex-grow-1 align-items-center" data-uit="apeer-file-tree-breadcrumb">
        <div *ngIf="!hideStaticHome" class="d-flex">
            <a class="d-flex" (click)="clickOnHome()">
                <span class="breadcrumb-caption">{{ rootTitle }}</span>
            </a>
            <ca-icon name="arrow-right" size="s" class="d-flex align-items-center ca-color-on-background-on-surface mx-1"></ca-icon>
        </div>
        <ng-container *ngFor="let folder of history; let index = index; last as isLast">
            <div class="d-flex" *ngIf="!isLast; else last">
                <a class="d-flex align-items-center">
                    <span [title]="folder.name" class="breadcrumb-caption" (click)="onNavigate(folder, index)" data-uit="apeer-file-tree-breadcrumb-name">
                        {{ folder.name || rootTitle }}
                    </span>
                </a>
                <ca-icon name="arrow-right" size="s" class="d-flex align-items-center ca-color-on-background-on-surface mx-1"></ca-icon>
            </div>
            <ng-template #last>
                <span [title]="folder.name" class="breadcrumb-caption breadcrumb-caption-active" data-uit="apeer-file-tree-breadcrumb-name">
                    {{ folder.name || rootTitle }}
                </span>
            </ng-template>
        </ng-container>
    </div>
</div>
